module.exports = __webpack_public_path__ + "static/media/GrandLuxxe.5d6e5450.png";